module.exports = __webpack_public_path__ + "assets/img/D3-Security-Content-Marketing-w720.331ba60f.webp";